/**
 * Settings Service
 * Handles API calls for settings: profile, security, organization, API keys, danger zone
 */
import api from './api';
import authService from './auth';

class SettingsService {
  // ===== Profile =====

  async getProfile() {
    const response = await api.get('/api/users/me');
    return response.data;
  }

  async updateProfile(profileData) {
    const response = await api.put('/api/users/me', profileData);
    return response.data;
  }

  // ===== Security =====

  async changePassword(passwordData) {
    const response = await api.put('/api/users/me/password', passwordData);
    return response.data;
  }

  async getActiveSessions() {
    const response = await api.get('/api/me/sessions');
    return response.data;
  }

  async revokeSession(sessionId) {
    const response = await api.delete(`/api/me/sessions/${sessionId}`);
    return response.data;
  }

  async revokeAllSessions() {
    const response = await api.post('/api/me/sessions/revoke-all');
    return response.data;
  }

  // ===== Organization =====

  async getCompanyInfo() {
    const response = await api.get('/api/company');
    return response.data;
  }

  async updateCompanyInfo(companyData) {
    const response = await api.put('/api/company', companyData);
    return response.data;
  }

  // ===== Notifications (new-widget-chat alerts) =====

  async getNotificationSettings() {
    const response = await api.get('/api/company/notifications');
    return response.data;
  }

  async updateNotificationSettings(settings) {
    const response = await api.put('/api/company/notifications', settings);
    return response.data;
  }

  async getTeamMembers() {
    const response = await api.get('/api/company/members');
    return response.data;
  }

  async inviteTeamMember(email, role) {
    const response = await api.post('/api/company/members', { email, role });
    return response.data;
  }

  async updateMemberRole(userId, role) {
    const response = await api.put(`/api/company/members/${userId}`, { role });
    return response.data;
  }

  async removeTeamMember(userId) {
    const response = await api.delete(`/api/company/members/${userId}`);
    return response.data;
  }

  async updateMemberPermissions(userId, permissions) {
    const response = await api.put(`/api/company/members/${userId}/permissions`, { permissions });
    return response.data;
  }

  async getEntitlements() {
    const response = await api.get('/api/company/entitlements');
    return response.data;
  }

  // ===== API Keys =====

  async getApiKeys() {
    const response = await api.get('/api/company/api-keys');
    return response.data;
  }

  async generateApiKey(name) {
    const response = await api.post('/api/company/api-keys', { name });
    return response.data;
  }

  async revokeApiKey(keyId) {
    const response = await api.delete(`/api/company/api-keys/${keyId}`);
    return response.data;
  }

  // ===== Danger Zone =====

  async deleteAccount(password) {
    const response = await api.delete('/api/me', { data: { password } });
    return response.data;
  }

  async deleteCompanyData(password) {
    const response = await api.delete('/api/company', { data: { password } });
    return response.data;
  }
}

const settingsService = new SettingsService();
export default settingsService;
